import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { getAppInsights } from './appinsights/TelemetryService';
import TelemetryProvider from './appinsights/telemetry-provider';
import './custom.css';
import Header from './components/Header';
import Home from './pages/Home';
import Events from './pages/Events';
import Details from './pages/Details';
import Error from './pages/Error';
import TestBlob from './pages/Blob';
import Budget from './pages/Budget';
import ProgressIndicator from './components/ProgressIndicator';

import { GlobalProvider } from './context/GlobalState';

import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { msalConfig, loginRequest, appInsightKey } from './authConfig';
import CacheBuster from './CacheBuster';

export default function App() {
    let appInsights = null;
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts, inProgress } = useMsal();
    const location = useLocation();

    useEffect(() => {
        if (!isAuthenticated && inProgress === 'none') {
            instance.loginRedirect(loginRequest).catch((error) => { });
        }
    }, [isAuthenticated, instance, inProgress]);

    const validateUserRole = () => {
        for (let account of accounts) {
            if (
                account.idTokenClaims &&
                account.idTokenClaims.aud === msalConfig.auth.clientId
            ) {
                if (
                    account.idTokenClaims.roles &&
                    account.idTokenClaims.roles.includes('EstateManager')
                )
                    return true;
            }
        }
        return false;
    };

    return (
        <TelemetryProvider
            instrumentationKey={appInsightKey}
            after={() => {
                appInsights = getAppInsights();
            }}
        >
            <CacheBuster>
                {({
                    loading, isLatestVersion, refreshCacheAndReload}) => {
                    if (loading) return null;
                    if (!loading && !isLatestVersion) {
                        refreshCacheAndReload();
                    }
                    return (
                        <GlobalProvider>
                            {isAuthenticated && validateUserRole() ? (
                                <>
                                    <Header />
                                    <Routes location={location}>
                                        <Route path='/' element={<Home />} />
                                        <Route path='/events/:status/:propertyType' element={<Events />} />
                                        <Route path='/events/:status/:propertyType/:squery' element={<Events />} />
                                        <Route path='/details/:id' element={<Details />} />
                                        <Route path='/testblob' element={<TestBlob />} />
                                        <Route path='/budget' element={<Budget />} />
                                    </Routes>
                                </>

                            ) : !isAuthenticated ? (
                                <ProgressIndicator />
                            ) : !validateUserRole() ? (
                                <>
                                    <Header />
                                    <Error />
                                </>
                            ) : (
                                <></>
                            )}
                        </GlobalProvider>
                    );
                }}
            </CacheBuster>

        </TelemetryProvider>

    );
}
